import statusLabel from './statusLabel'

const orders = {
  statusLabel,
}

export default orders
